import { Component, OnInit, Input, Output, EventEmitter, NgZone } from '@angular/core';
import { EditableFault, FaultState } from '../shared/editable-fault/editable-fault';
import { WeblinkFault } from '../shared/weblink-fault/weblink-fault';
import { Status } from '../../core/status/status';
import { FaultFieldMapping } from '../shared/fault-field-mapping/fault-field-mapping';
import { WeblinkFaultService } from '../shared/weblink-fault.service';
import { SafeUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormatPipe } from '../shared/format.pipe';
import { TileLayout } from '../shared/tile-layout/tile-layout';
import { ResponsiveComponent } from '../shared/responsive/responsive.component';
import { MediaQueryService } from '../shared/responsive/services/media-query.service';
import {WeblinkSettings} from "@docma-weblink/shared/weblink-data/weblink-data";

@Component({
  selector: 'app-weblink-fault-detail',
  templateUrl: './weblink-fault-detail.component.html',
  styleUrls: ['./weblink-fault-detail.component.scss']
})
export class WeblinkFaultDetailComponent extends ResponsiveComponent implements OnInit {

  @Output() checkChanged: EventEmitter<any> = new EventEmitter();
  @Output() editFault: EventEmitter<{fault: EditableFault, settings: WeblinkSettings}> = new EventEmitter();
  @Output() showLastActivity: EventEmitter<EditableFault> = new EventEmitter();
  @Output() attachmentClick: EventEmitter<EditableFault> = new EventEmitter<EditableFault>();


  @Input() fault: EditableFault;
  @Input() settings?: WeblinkSettings;
  @Input() status: Status[];
  @Input() fields: FaultFieldMapping[];
  @Input() layout: TileLayout;

  @Input() search = 'Mangel';
  header: string = '';
  hideDetails = true;
  //hideImage = false;

  public FaultState = FaultState;

  constructor(private faultService: WeblinkFaultService,  mediaQueryService: MediaQueryService  ) {
    super(mediaQueryService);
   }

  ngOnInit() {

    if(this.layout.captionProperties.length===1){
      this.header = this.getFormattedValueForProperty(this.layout.captionProperties[0].FieldId);
    } else if (this.layout.captionProperties.length>=2) {
      this.header =
        `#${this.getFormattedValueForProperty(
          this.layout.captionProperties[0].FieldId)} ${this.getFormattedValueForProperty(this.layout.captionProperties[1].FieldId)}`;
    } else {
      this.header = 'no fields!';
    }
  }

  getFormattedValueForProperty(key: string): string {
    return FormatPipe.transform(this.getValueForProperty(key));
  }

  getValueForProperty(key: string): any {
    let prop = this.fault.Data.find( data => data.Key === key);
    if(prop) {
      return prop.Val;
    } else {
      return '';
    }
  }

  onAttachmentClick(id:number){
    this.attachmentClick.emit(this.fault);
  }

  changeCheck() {
    if (!this.fault.newStatus && this.fault.IsEditable && !this.fault.IsClosed) {
      this.fault.isSelected = !this.fault.isSelected;
      this.checkChanged.emit(this);
      } else {
        this.fault.isSelected = false;
    }
  }

  edit() {
    this.editFault.emit({fault: this.fault, settings: this.settings});
  }

  show() {
    this.showLastActivity.emit(this.fault);
  }

  dateToLocalDate(date: string): string {
    return new Date(Date.parse(date)).toLocaleDateString();
  }

  toggleDetails() {
    this.hideDetails = !this.hideDetails;
  }
}
